import { WSTimelineItemProps } from "@wingspanhq/fe-component-library";
import { components } from "../../../services/api/resourceEvents/types";
import { EventContent } from "./EventContent";
import { EventGroupContent } from "./EventGroupContent";
import { EventGroup } from "./types";

const getInitials = (name: string): string =>
  name
    .split(" ")
    .map(word => word[0])
    .join("");

const createAvatar = (
  userName: string | undefined,
  actorName: string
): WSTimelineItemProps["avatar"] =>
  userName
    ? { type: "text", text: getInitials(actorName) }
    : { type: "icon", icon: "bot" };

export function eventGroupToTimeline(
  group: EventGroup,
  isCompact?: boolean,
  drillDownResourceType?: string,
  onDrillDown?: (resource: components["schemas"]["IEventResource"]) => void
): WSTimelineItemProps {
  if (group.type === "single") {
    const actorName = group.event.userName || "Automated";

    return {
      content: (
        <EventContent
          isCompact={isCompact}
          event={group.event}
          drillDownResourceType={drillDownResourceType}
          onDrillDown={onDrillDown}
        />
      ),
      date: group.event.timestamp,
      dateFormat: "default",
      avatar: createAvatar(group.event.userName, actorName),
      pills: [actorName]
    };
  }

  const actorName = group.actor;
  const hasUserName = actorName !== "Automated";

  return {
    content: (
      <EventGroupContent
        group={group}
        isCompact={isCompact}
        drillDownResourceType={drillDownResourceType}
        onDrillDown={onDrillDown}
      />
    ),
    date: group.anchorTimestamp,
    dateFormat: "default",
    avatar: createAvatar(hasUserName ? actorName : undefined, actorName),
    pills: [actorName]
  };
}
